class ParseResumeApi {
  baseUrl = "/api";

  storeResume(formData) {
    return axios.post(`${this.baseUrl}/store-resume`, formData, {
      headers: {"Content-Type": "multipart/form-data"}
    });
  }

  parseResumeContactInfo(uuid) {
    return axios.post(`${this.baseUrl}/parse-resume-contact-info`, {uuid});
  }

  show(uuid) {
    return axios.get(`${this.baseUrl}/resumes/${uuid}`);
  }

  parseResumeContent(uuid) {
    const endpoint = `${this.baseUrl}/parse-resume-content`;

    const encodedUuid = encodeURIComponent(uuid);

    return new EventSource(`${endpoint}?uuid=${encodedUuid}`);
  }

  searchIndustriesAndJobTitles(jobTitleSearchTerms = [], industrySearchTerms = [], recaptcha = "") {
    const endpoint = `${this.baseUrl}/search-industries-and-job-titles`;

    let queryParams = [];
    jobTitleSearchTerms.forEach(term => queryParams.push(`job-title-search-terms[]=${encodeURIComponent(term)}`));
    industrySearchTerms.forEach(term => queryParams.push(`industry-search-terms[]=${encodeURIComponent(term)}`));
    if (recaptcha) queryParams.push(`g-recaptcha-response=${encodeURIComponent(recaptcha)}`);

    const queryString = queryParams.join("&");

    return axios.get(`${endpoint}?${queryString}`);
  }
}

export default ParseResumeApi;
